import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createForm: false,
  editObj: null,
  report: false,
};

export const depositSlice = createSlice({
  name: "deposit",
  initialState,
  reducers: {
    showCreateForm: (state) => {
      state.createForm = !state.createForm;
    },

    setEditObj: (state, { payload }) => {
      console.log("norkkking", payload);
      state.editObj = payload;
    },
    showReportForm: (state) => {
      state.report = !state.report;
    },
  },
  extraReducers: (builder) => {},
});

export const { showCreateForm, setEditObj, showReportForm } =
  depositSlice.actions;
export default depositSlice.reducer;
